import styled from 'styled-components';
import mediaQueries from 'constants/mediaQueries';

const DESKTOP_GAP = 96;
const MOBILE_GAP = 56;

const DESKTOP_PADDING = 32;
const MOBILE_PADDING = 28;

const desktopHeight = DESKTOP_GAP - DESKTOP_PADDING;
const mobileHeight = MOBILE_GAP - MOBILE_PADDING;

export const Wrapper = styled.div`
  width: 100%;
  height: ${desktopHeight}px;

  ${mediaQueries.mobileOnly} {
    height: ${mobileHeight}px;
  }
`;
